//
//
//
//
//
//
//

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {},
}
